module.exports = __webpack_public_path__ + "img/hn.66a9b7e7.svg";